import { AccountTransactionList } from "../tlSalesOnAccount";

const TLRecurringJV = () => <AccountTransactionList
  title="Recurring Journal Voucher"
  moduleId="ACTRJV"
  storageKey="recurringJV.filters"
  accessPath="/api/recurring-jv/access"
  statusPath="/api/recurring-jv/status"
  dataPath="/api/recurring-jv/list"
  generatePath="/api/recurring-jv/generate"
  transactionPath="/App/RecurringJVTransaction"
  documentPrefix="RJV"
  rowClassPrefix="rjv"
  moneyFields={["TotalDebit", "TotalCredit"]}
  additionalFields={["Status"]}
  filterByBranch={false}
  branchLabel="Working Branch"
  showListSearch
  centeredErrors
  hidePostActions
  hideUnauthorizedActions
  lockedEditStatuses={["GENERATED", "CANCELLED"]}
  summaryMode="recurring"
/>;

export default TLRecurringJV;
